'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var all = require('it-all');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var all__default = /*#__PURE__*/_interopDefaultLegacy(all);

function flat(_x, _x2) {
  return _flat.apply(this, arguments);
}

function _flat() {
  _flat = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, reduce) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = reduce;
            _context.next = 3;
            return all__default['default'](source);

          case 3:
            _context.t1 = _context.sent;
            return _context.abrupt("return", (0, _context.t0)(_context.t1));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _flat.apply(this, arguments);
}

module.exports = flat;